import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';
import React from 'react';

import type { IFacebookPage } from '@feathr/blackbox';

import * as styles from './FacebookPageSelect.css';

/* UniversalSelect calls this for both the menu rows and the selected value. */
export function formatFacebookPageOptionLabel(data: IFacebookPage): ReactNode {
  const {
    instagram: { instagram_user_id: instagramActorId, username: instagramUsername },
    name,
  } = data;

  return (
    <div className={styles.root}>
      <div>
        <FontAwesomeIcon icon={faFacebook} />
        {name}
      </div>
      {!!instagramActorId && (
        <div className={styles.instagramIndicator}>
          <FontAwesomeIcon icon={faInstagram} /> {instagramUsername}
        </div>
      )}
    </div>
  );
}
